import { useMemo } from "react";
import { GroupType, type OtherFieldGroup, ResponseItemType, useMetadataQuery } from "@/entities/form-metadata";

export const useOtherFieldsWithExactnessDisabled = () => {
    const { data: formMetadata } = useMetadataQuery();

    return useMemo(() => {
        const disabled = new Set<string>();
        for (const entry of formMetadata.fieldGroupsAndFeatureContainers) {
            if (entry.type === ResponseItemType.FieldGroup && entry.groupType === GroupType.Other) {
                const otherGroup = entry as OtherFieldGroup;
                for (const item of otherGroup.others) {
                    const field = item.fields[0];
                    if (field && field.features.showExactness === false) {
                        disabled.add(`${item.relation}${item.eventType}${item.assertion}`);
                    }
                }
            }
        }
        return disabled;
    }, [formMetadata.fieldGroupsAndFeatureContainers]);
};
